import React from 'react';
import BaseRow from '../BaseRow';
import { useHeaderRef } from '../../services/headerSizeCalculator';
import styles from './index.module.scss';

const HeaderRow = ({ children }) => {
  const headerRef = useHeaderRef();

  return (
    <BaseRow rootRef={headerRef} className={styles.root}>
      {children}
    </BaseRow>
  );
};

export default HeaderRow;
